<template>
    <!--弹窗-->
    <el-dialog
        width="700px"
        class="plural"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
    >
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="日期:">
                <el-date-picker style="width: 150px;" v-model="query.date" type="date"
                                placeholder="请选择日期" size="mini" value-format="yyyy-MM-dd"/>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="queryList">查询</el-button>
                <el-button type="success" @click="updateNow">更新当日</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" size="mini" border height="450">
            <el-table-column prop="id" label="ID" width="100" align="center"></el-table-column>

            <el-table-column label="日期" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.date }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" width="140" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.create_time }}</div>
                </template>
            </el-table-column>


            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="success" @click="downFile(scope.row.download_path)" size="mini">下载</el-button>
                    <el-button type="danger" size="mini" @click="delete_records(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                @click="handleClose">关 闭
            </el-button>
        </el-row>
        <addPlural @close="getList" ref="addPluralDom"></addPlural>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product.js'
    import addPlural from './components/addPlural'
    import {
        auto_optimize_acos_excel_list_delete,
        auto_optimize_acos_excel_list_lists,
        operating_asin_task_crontab_create_auto_optimize_acos
    } from '@/api/Product/Product.js'
    import {downloadFileUrl} from '@/utils/method'

    export default {
        data() {
            return {
                state: 'us',
                loading: false,
                list: [],
                keyword: '',
                query: {
                    date: undefined,
                    page: 1,
                    limit: 10,
                    total: 0,
                },
            }
        },
        components: {addPlural},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            }
        },
        methods: {
            queryList(){
              this.query.page = 1
              this.getList()
            },
            getList() {
                this.loading = true
                this.query.region = this.state
                api.auto_optimize_acos_excel_list_lists(this.query)
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.total = res.data.total
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            updateNow(){
                this.loading = true
                api.operating_asin_task_crontab_create_auto_optimize_acos({region: this.state}).then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '更新成功'})
                            this.getList()
                        } else {
                            this.$notify({title: '更新失败', message: res.message, duration: 0});
                        }
                }).catch(() => {
                        this.loading = false
                    })
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            delete_records(data) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.auto_optimize_acos_excel_list_delete({id: data.id}).then(() => {
                        this.$message.success('删除成功')
                        this.getList()
                    })
                })
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            submitForm(data) {
                if (this.list.length == 0) {
                    return this.$message({
                        type: 'error',
                        message: '请输入单词进行搜索单词具体数据!'
                    })
                }

                let str = JSON.parse(JSON.stringify(data.plural_keywords || ''))
                str = str.replace(/\s*(,|，)\s*/g, ',').trim()

                api.seed_word_asin_list_update_singular_plural({id: data.id, plural_keywords: str})
                    .then(res => {
                        this.loading = false
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '修改成功'})
                            this.getList()
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '网络出现问题，请查看数据是否添加完成！'
                        })
                    })
            },
            // 关闭弹窗
            handleClose() {
                this.disabled = false
                this.list = []
                this.keyword = ''
                this.$emit('close-callback', true)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .plural {
        /deep/ .el-table__empty-block {
            border-bottom: 1px #ebeef5 solid;
        }

        /deep/ .el-dialog__body {
            padding-top: 0 !important;
        }
    }
</style>
